import {
  Tooltip as ShadcnTooltip,
  TooltipContent as ShadcnTooltipContent,
  TooltipTrigger as ShadcnTooltipTrigger,
} from '@workspace/ui/components/tooltip';

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  contentOptions?: React.ComponentProps<typeof ShadcnTooltipContent>;
}

export function Tooltip({ children, content, contentOptions }: TooltipProps) {
  return (
    <ShadcnTooltip>
      <ShadcnTooltipTrigger asChild>{children}</ShadcnTooltipTrigger>
      <ShadcnTooltipContent className='z-[300]' {...contentOptions}>
        {content}
      </ShadcnTooltipContent>
    </ShadcnTooltip>
  );
}
